import React, { useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../components/Context/AuthContext";
import { Box, TextField, Button, Typography, Alert } from "@mui/material";
import API_URL from "../../config";
import API_BASE_URL from "../../utils/api";

const WorkshopAccess = () => {
  const { user, setUser } = useContext(AuthContext);
  const [code, setCode] = useState("");
  const [showInput, setShowInput] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    setError("");
    setSuccess("");
    try {
      const res = await axios.post(
        `${API_BASE_URL}/auth/redeem-workshop-code`,
        {
          code,
        }
      );
      setUser({ ...user, workshopAccess: true });
      setSuccess(res.data.message);
      setShowInput(false);
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong.");
    }
  };

  if (user?.workshopAccess) {
    return (
      <Alert severity="success">
        🎉 You already have access to the workshop resources.
      </Alert>
    );
  }

  return (
    <Box mt={4}>
      <Alert severity="info" sx={{ mb: 2 }}>
        Access to the workshop materials requires a unique code.
        <br />
        <strong>Codes have not been distributed yet.</strong> You will receive
        yours via email once registration is complete.
      </Alert>

      {/* Keep this hidden for now if you haven’t sent codes */}
      {!showInput ? (
        <Button variant="contained" onClick={() => setShowInput(true)}>
          Enter Access Code
        </Button>
      ) : (
        <>
          <Typography variant="h6" gutterBottom>
            Enter Your Workshop Access Code
          </Typography>
          <TextField
            label="Access Code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            fullWidth
            sx={{ mb: 2 }}
          />
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={!code.trim()}
          >
            Submit Code
          </Button>
        </>
      )}

      {success && (
        <Alert severity="success" sx={{ mt: 2 }}>
          {success}
        </Alert>
      )}
      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </Box>
  );
};

export default WorkshopAccess;
